import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IEmailTemplateModel } from '../Shared/model/EmailTemplateModel';

@Injectable({
    providedIn: 'root',
})

export class WebInquirySettingsService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    getWebInquiryVendors(status: number) {
        return this.http.get<any>(
            `${this.baseURL}/WebInquirySettings/GetWebInquiryVendors?vendorStatus=${status}`,
            { observe: 'response' }
        ).pipe(map(res => res.body));
    }

    getWebInquiryUser(vendorId: number): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/WebInquirySettings/GetWebInquiryUser?vendorId=${vendorId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    return res.body as any;
                }),
                catchError(this.handleError)
            );
    }

    saveWebInquiryUser(model: any): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<any>(
            `${this.baseURL}/WebInquirySettings/SaveWebInquiryUser`,
            model,
            { headers }
        ).pipe(
            map(res => {
                return res as any;
            }),
            catchError(this.handleError)
        );
    }

    getWebInquiryGeneralSettings() {
        return this.http.get<any>(
            `${this.baseURL}/WebInquirySettings/GetWebInquiryGeneralSettings`
        );
    }

    saveWebInquiryGeneralSettings(model: any) {
        return this.http.post<any>(
            `${this.baseURL}/WebInquirySettings/SaveWebInquiryGeneralSettings`, model
        );
    }

    webInquiryLoginDetailsEmail(vendorId: number): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/WebInquirySettings/WebInquiryLoginDetailsEmail`,
            { vendorId },
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    // =====================
    // Vendor Message APIs
    // =====================
    getVendorMessage(vendorId: number): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/WebInquirySettings/GetVendorMessage?vendorId=${vendorId}`
        ).pipe(
            map(res => res),
            catchError(this.handleError)
        );
    }

    saveVendorMessage(model: { vendorId: number; messageForVendor: string }) {
        const payload = {
            VendorId: model.vendorId,
            MessageForVendor: model.messageForVendor
        };

        return this.http.post<any>(
            `${this.baseURL}/WebInquirySettings/SaveVendorMessage`,
            payload,
            { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
        );
    }

    getDefaultWebInquiryUserId(): Observable<number> {
        return this.http.get<number>(
            `${this.baseURL}/WebInquirySettings/GetDefaultWebInquiryUserId`,
            { observe: 'response' }
        ).pipe(
            map(res => res.body as number),
            catchError(this.handleError)
        );
    }

    saveWebInquiryUserId(userId: number): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/WebInquirySettings/SaveWebInquiryUserId`,
            userId,
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            // this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }

}
